<script lang="ts" setup>
const { t } = useI18n({
  useScope: "global",
});
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  value: {
    type: [String, Number, Date],
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
  link: {
    type: String,
    default: null,
  },
});

const formatTextLike = (value) => {
  if (!value && value !== 0) {
    return t("common.unknown");
  }

  return value;
};

const currentType = computed(() => {
  if (props.type === "link" && props.link && props.link.indexOf("http") !== -1) {
    return "link";
  }

  if (props.type === "text") {
    return "text";
  }

  if (props.type === "date") {
    return "date";
  }
  return "text";
});
</script>

<template>
  <div class="cars-info-item">
    <span class="title"><slot name="title">{{ props.title }}</slot>:</span>
    <span
      v-if="currentType === 'text'"
      class="value"
    >
      <slot>{{ formatTextLike(props.value) }}</slot>
    </span>
    <span
      v-if="currentType === 'date'"
      class="value"
    >
      <slot>
        <FormatDate :date="props.value" />
      </slot>
    </span>
    <template v-if="currentType == 'link'">
      <span class="value">
        <slot>
          <a
            :href="props.link"
            rel="noopener noreferrer"
            target="_blank"
          >{{ props.value }}</a>
        </slot>
      </span>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.cars-info-item {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  margin-bottom: 15px;

  @media only screen and (max-width: $tablet) {
    margin-bottom: 10px;
    min-width: 50%;
    white-space: nowrap;
    font-size: 11px;
  }

  &.row {
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;

    .title {
      margin-right: 5px;
      margin-bottom: 0;
    }
  }

  .title {
    font-weight: 700;
    margin-bottom: 5px;
  }

  .value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    img {
      width: 60px;
      height: auto;
    }
  }
}
</style>
